import {
    ClickElement,
    ClickText,
    GA4EventName,
    GA4FeatureCategory,
    trackAnalyticsEvent,
} from '@jsmdg/tracking';
import { TRACKING_LABEL } from './shareOptions';

const clickElementMap = {
    [TRACKING_LABEL.WHATS_APP]: ClickElement.WhatsApp,
    [TRACKING_LABEL.COPY_LINK]: ClickElement.Link,
    [TRACKING_LABEL.EMAIL]: ClickElement.EMail,
    [TRACKING_LABEL.CLOSE]: ClickElement.Close,
};

const clickTextMap = {
    [TRACKING_LABEL.WHATS_APP]: ClickText.WhatsApp,
    [TRACKING_LABEL.COPY_LINK]: ClickText.CopyLink,
    [TRACKING_LABEL.EMAIL]: ClickText.SendEmail,
    [TRACKING_LABEL.CLOSE]: ClickText.Close,
};

const trackSocialShareAction = (label: string): void => {
    setTimeout(
        () =>
            trackAnalyticsEvent({
                category: 'ProductDetail',
                action: 'SocialShare',
                label,
                eventData: {
                    eventName: GA4EventName.Share,
                    feature_category: GA4FeatureCategory.ProductdetailBuybox,
                    click_element: clickElementMap[label],
                    click_text: clickTextMap[label],
                },
            }),
        0,
    );
};

const trackWhatsAppUnavailable = (): void => {
    setTimeout(
        () =>
            trackAnalyticsEvent({
                category: 'ProductDetail',
                action: 'Error',
                label: 'SocialShare_whatsappUnavailable',
                eventData: {
                    eventName: GA4EventName.ShowNotification,
                    feature_category: GA4FeatureCategory.ProductdetailBuybox,
                    notification_type: 'Error - social share whatsapp unavailable',
                    notification_message:
                        'Es scheint so, als wäre WhatsApp nicht auf deinem Smartphone installiert. Bitte nutze zum Teilen eine andere Methode.',
                },
            }),
        0,
    );
};

export { trackSocialShareAction, trackWhatsAppUnavailable };
